import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {MatLegacySlideToggleModule as MatSlideToggleModule} from '@angular/material/legacy-slide-toggle';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatLegacyListModule as MatListModule} from '@angular/material/legacy-list';
import {MatLegacyCardModule as MatCardModule} from '@angular/material/legacy-card';
import {MatLegacyTabsModule as MatTabsModule} from '@angular/material/legacy-tabs';
import {MatLegacyChipsModule as MatChipsModule} from '@angular/material/legacy-chips';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {MatLegacySnackBarModule as MatSnackBarModule} from '@angular/material/legacy-snack-bar';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';
import {MatSortModule} from '@angular/material/sort';
import {MatLegacyPaginatorModule as MatPaginatorModule} from '@angular/material/legacy-paginator';
import {MatLegacyPaginatorIntl as MatPaginatorIntl} from '@angular/material/legacy-paginator';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {TranslateService} from '@ngx-translate/core';
import {Injectable} from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/ru';

moment().locale('ru');

export const MY_FORMATS = {
    parse: {
        dateInput: 'L',
    },
    display: {
        dateInput: 'L',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export const PAGINATOR_LANG_KEYS = {
    firstPageLabel: 'label_paginator_first_page',
    lastPageLabel: 'label_paginator_last_page',
    nextPageLabel: 'label_paginator_next_page',
    previousPageLabel: 'label_paginator_prev_page',
    itemsPerPageLabel: 'label_paginator_items_per_page',
    getRangeLabel: 'label_paginator_current_position'
};

@Injectable()
export class LocalizedPaginator extends MatPaginatorIntl {
    ofLabel = 'of';

    constructor(private translate: TranslateService) {
        super();

        this.setTranslations();
    }

    setTranslations() {
        this.translate.get([
            'label_paginator_first_page',
            'label_paginator_last_page',
            'label_paginator_next_page',
            'label_paginator_prev_page',
            'label_paginator_items_per_page',
            'label_paginator_current_position'
        ]).subscribe(translation => {
            this.firstPageLabel = translation['label_paginator_first_page'];
            this.lastPageLabel = translation['label_paginator_last_page'];
            this.nextPageLabel = translation['label_paginator_next_page'];
            this.previousPageLabel = translation['label_paginator_prev_page'];
            this.itemsPerPageLabel = translation['label_paginator_items_per_page'];
            this.ofLabel = translation['label_paginator_current_position'];
            this.changes.next();
        });
    }

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 ${this.ofLabel} ${length}`;
        }

        length = Math.max(length, 0);

        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} ${this.ofLabel} ${length}`;
    };
}

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatInputModule,
        MatButtonModule,
        MatListModule,
        MatIconModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatCheckboxModule,
        MatDialogModule,
        MatSelectModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatSidenavModule,
        MatTableModule,
        MatMenuModule,
        MatSortModule,
        MatButtonToggleModule
    ],
    exports: [
        MatCardModule,
        MatInputModule,
        MatButtonModule,
        MatListModule,
        MatIconModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatCheckboxModule,
        MatDialogModule,
        MatSelectModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatTooltipModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatSidenavModule,
        MatTableModule,
        MatMenuModule,
        MatSortModule,
        MatButtonToggleModule
    ],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
        {provide: MatPaginatorIntl, useClass: LocalizedPaginator}
    ],
})
export class UiModule {
}
